import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { FormField } from '../../_shared/formfield/formfield.component';
import { ReadOnlyContentComponent } from '../../_shared/readonlycontent/readonlycontent.component';
import SubmissionHandler from '../../_shared/submissionhandler/submissionhandler';
import Header from '../../_shared/header/header';
import Footer from '../../_shared/footer/footer';
import flatten from '../../_shared/util/flatten';
import { Helmet } from 'react-helmet';

@inject('routerStore', 'store', 'form', 'appStore', 'startStore')
@observer
export class FloorAreaComponent extends Component {
    onPrevious() {
        const { routerStore, store, form } = this.props,
            { history } = routerStore;

        store.save(form.values(), false);
        history.push({ pathname: '/gettingstarted/homedetails', state: { transition: 'back' } });
    }

    onStartOver(e) {
        const { history } = this.props.routerStore;
        history.push({ pathname: '/', state: { transition: 'back' } });
    }

    render() {
        const { form, store, appStore } = this.props,
            errors = form.errors();

        return <section className='ht-page ht-floorarea'>
            <Helmet>
                <title>About your Main Living Room &raquo; {appStore.baseTitle}</title>
            </Helmet>
            <Header
                titlePre='Tell us about your'
                title='Main Living room'
                idPrefix='floorareadetails'
                prevActionName='prev-floorareadetails-to-homedetails'
                prev={{
                    onClick: () => this.onPrevious()
                }}
            />
            <SubmissionHandler store={store}>
                <form className='ht-form'>
                    {store.isReadOnly && <ReadOnlyContentComponent
                        onClick={e => this.onStartOver(e)}
                    />}
                    {form.map(field => {
                        field.errors = errors[field.path];
                        return <FormField
                            key={field.id}
                            field={field}
                            formValues={flatten(form.values())}
                        />
                        ;
                    })}

                    {!store.isReadOnly && <div className='ht-formnote' role='note'>
                        <div className='ht-formnote-content'>
                            <h3 className='ht-formnote-heading'>Before you continue&hellip;</h3>
                            <p>Please note: the information you've supplied in sections one and two can't be
                                altered once you start adding walls. You'll be able to view the information but it can't
                                be amended in any way.
                            </p>
                            <p>
                                If you are happy with the information you've supplied, you can continue by using the button
                                below.
                            </p>
                        </div>
                    </div>}

                    <Footer
                        idPrefix='floorareadetails'
                        prevActionName='prev-floorareadetails-to-homedetails'
                        nextActionName='next-floorareadetails-to-wall'
                        next={{
                            text: 'Start adding walls',
                            loading: store.loading,
                            disabled: !form.isValid || (store.error && store.error.code),
                            onClick: e => form.onSubmit(e)
                        }}
                        prev={{
                            onClick: () => this.onPrevious()
                        }}
                        showError={!form.isValid}
                        errorMessage={form.error}
                        emailProgressLinkSupText={window.HTContent.EmailProgressLinkSupText}
                    />
                </form>
            </SubmissionHandler>
        </section>;
    }
}
